import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { okaidia, prism } from "react-syntax-highlighter/dist/esm/styles/prism";
import CodeToolbar from "./CodeToolbar/CodeToolbar";

function Code({ codeSnippet }) {
  // Convert language to the correct format for display
  const formatLanguage = (lang) => {
    if (!lang) return "text";

    const language = lang.toLowerCase();

    // Special cases
    if (language === "csharp") return "C#";
    if (language === "javascript") return "JavaScript";
    if (language === "typescript") return "TypeScript";
    if (language === "python") return "Python";
    if (language === "java") return "Java";
    if (language === "cpp") return "C++";
    if (language === "c") return "C";
    if (language === "html") return "HTML";
    if (language === "css") return "CSS";
    if (language === "sql") return "SQL";
    if (language === "json") return "JSON";
    if (language === "xml") return "XML";
    if (language === "yaml") return "YAML";
    if (language === "markdown") return "Markdown";
    if (language === "bash") return "Bash";
    if (language === "shell") return "Shell";
    if (language === "powershell") return "PowerShell";
    if (language === "assembly") return "asm";

    // Default: capitalize first letter
    return language.charAt(0).toUpperCase() + language.slice(1);
  };

  const language = formatLanguage(codeSnippet.Language);

  return (
    <>
      {codeSnippet.Title && (
        <h2 className="n-color-purple">{codeSnippet.Title}</h2>
      )}

      <div className="card" dir="ltr">
        <div className="card-body">
          <CodeToolbar languageIcon={language} codeSnippet={codeSnippet.Code} />
          <div className="overflow-auto text-white bg-dark p-2 fs-6 rounded-bottom-3">
            <SyntaxHighlighter
              language={codeSnippet.Language?.toLowerCase() || "text"}
              style={okaidia}
              showLineNumbers
              wrapLongLines={false}
              className="rounded-top-0 mt-0"
            >
              {codeSnippet.Code}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>

      <div className="card d-none" dir="ltr">
        <div className="card-body">
          <CodeToolbar languageIcon={language} codeSnippet={codeSnippet.Code} />
          <div className="overflow-auto text-white bg-white fs-6 rounded-bottom-3">
            <SyntaxHighlighter
              language={codeSnippet.Language?.toLowerCase() || "text"}
              style={prism}
              showLineNumbers
              wrapLongLines={false}
              className="rounded-top-0 mt-0"
            >
              {codeSnippet.Code}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
    </>
  );
}

export default Code;
